import { EmailOutlined, SquareRounded } from "@mui/icons-material";
import {
  Autocomplete,
  Button,
  Checkbox,
  FormControlLabel,
  InputAdornment,
  TextField,
  ThemeProvider,
} from "@mui/material";
import boxIcon from "assets/icons/box.svg";
import axios from "axios";
import CustomText from "components/typography/CustomText";
import { SERVER_URL } from "lib/global";
import { serverPost } from "lib/serverRequest";
import { useSnackbar } from "notistack";
import { openLoading } from "store/reducers/tools";
import { darkTheme } from "theme";

export const voucherOptions = Array.from(Array(12).keys()).map(
  (item, index) => ({
    label: `${index + 1} x Pie Club Boxes`,
    id: index + 1,
  })
);

export const downloadVoucher = (app = {}) => {
  axios
    .get(`${SERVER_URL}/api/vouchercode/print-pdf`, {
      params: {
        code: app.code ?? "",
        box_count: app.count?.id ?? 3,
      },
      responseType: "arraybuffer",
    })
    .then((res, err) => {
      openLoading(false);
      if (res.status === 200) {
        const file = new Blob([res.data], { type: "application/pdf" });
        const fileURL = URL.createObjectURL(file);
        const link = document.createElement("a");
        link.target = "_blank";
        link.download = "voucher.pdf";
        link.href = fileURL;
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
      }
    })
    .catch((err) => {
      console.log("err", err);
      openLoading(false);
    });
};
export default function DeliveriesForm({
  data = {},
  onChange = () => {},
  onClose = () => {},
  onAdd = () => {},
}) {
  const { enqueueSnackbar } = useSnackbar();

  const handleChange = (e, v) => {
    onChange({ target: { name: "box_count", value: v } });
  };

  const handleCheck = (e) => {
    onChange({
      target: { name: e.target.name, value: Boolean(e?.target?.checked) },
    });
  };

  const handleClickNext = () => {
    if (!Boolean(data?.box_count?.id))
      return enqueueSnackbar("Boxes are required", { variant: "warning" });
    if (Boolean(data?.recipient) && !Boolean(data?.optional_email))
      return enqueueSnackbar("Please check email!", {
        variant: "warning",
      });
    openLoading(true);
    serverPost({
      url: "vouchercode/create/admin",
      data: {
        data: {
          ...data,
          remain_boxes: +data?.box_count?.id,
        },
      },
      onFinish: (res, err) => {
        if (res !== false) {
          onAdd(res ?? {});
          downloadVoucher(res?.data ?? {});
        } else {
          openLoading(false);
        }
      },
    });
  };
  return (
    <div className="px-8 py-16 w-voucher-box rounded-3xl">
      <CustomText className="text-2xl" font="zing" color="white">
        SELECT NUMBER OF BOX DELIVERIES:
      </CustomText>
      <ThemeProvider theme={darkTheme}>
        <Autocomplete
          fullWidth
          className="py-4"
          name="box_count"
          value={data?.box_count || null}
          options={voucherOptions}
          getOptionLabel={(option) => option.label}
          onChange={handleChange}
          renderInput={(params) => {
            return (
              <TextField
                {...params}
                placeholder="Click to select"
                fullWidth
                InputProps={{
                  ...params.InputProps,
                  startAdornment: (
                    <>
                      <InputAdornment position="start">
                        <img src={boxIcon} alt="box icon" />
                      </InputAdornment>
                      {params.InputProps.startAdornment}
                    </>
                  ),
                }}
              />
            );
          }}
        />
      </ThemeProvider>
      <div className="pt-3">
        <FormControlLabel
          className="flex items-center"
          control={
            <Checkbox
              color="primary"
              size="large"
              name="recipient"
              checked={data?.recipient ?? false}
              onChange={handleCheck}
              icon={
                <SquareRounded
                  sx={{ fill: "#fff" }}
                  color="white"
                  fontSize="large"
                />
              }
            />
          }
          label={
            <CustomText className="text-base flex" color="white">
              Send to Recipient
            </CustomText>
          }
        />
      </div>
      {Boolean(data?.recipient) && (
        <ThemeProvider theme={darkTheme}>
          <TextField
            name="optional_email"
            type="email"
            placeholder="Email"
            value={data?.optional_email ?? ""}
            onChange={onChange}
            fullWidth
            InputProps={{
              startAdornment: (
                <InputAdornment position="start">
                  <EmailOutlined fontSize="large" color="secondary" />
                </InputAdornment>
              ),
            }}
          />
        </ThemeProvider>
      )}
      <CustomText
        className="pt-10 pb-2 uppercase text-3xl"
        font="zing"
        color="white"
      >
        voucher total:{" "}
        {data?.box_count?.id
          ? data?.box_count?.id === 1
            ? `69`
            : `$${data?.box_count?.id * 65}`
          : ""}
      </CustomText>
      <div className="flex items-center">
        <Button
          className="uppercase px-6 text-2xl font-zing"
          variant="contained"
          onClick={handleClickNext}
        >
          Create Voucher
        </Button>
      </div>
    </div>
  );
}
